import React, { useState, MouseEvent } from 'react'
import { IconButton, Menu, MenuItem, Box } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { UserEntity } from '@finance-lab/utils/types'

function UserActionsMenu({
    user,
    onSetUserCategory,
    onDisconnectClick,
    onDeleteUser,
    onChangePassword,
    onViewDevices,
}: {
    user: UserEntity
    onSetUserCategory?: (user: UserEntity) => void
    onDisconnectClick?: (user: UserEntity) => void
    onDeleteUser?: (id: string) => void
    onChangePassword?: (user: UserEntity) => void
    onViewDevices?: (user: UserEntity) => void
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const isInactive = user.userCategory === 'disabled'

    const handleMenuOpen = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget)
    const handleMenuClose = () => setAnchorEl(null)

    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', minHeight: 40 }}>
            <IconButton onClick={handleMenuOpen}>
                <MoreVertIcon />
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                {onSetUserCategory && (
                    <MenuItem
                        onClick={() => {
                            onSetUserCategory(user)
                            handleMenuClose()
                        }}
                    >
                        Ändra kategori
                    </MenuItem>
                )}
                {user.customerName && onDisconnectClick && (
                    <MenuItem
                        onClick={() => {
                            onDisconnectClick(user)
                            handleMenuClose()
                        }}
                    >
                        Koppla loss
                    </MenuItem>
                )}
                {onDeleteUser && (
                    <MenuItem
                        onClick={() => {
                            onDeleteUser(user.id)
                            handleMenuClose()
                        }}
                    >
                        Ta bort
                    </MenuItem>
                )}
                {!isInactive && onChangePassword && (
                    <MenuItem
                        onClick={() => {
                            onChangePassword(user)
                            handleMenuClose()
                        }}
                    >
                        Lösen
                    </MenuItem>
                )}
                {onViewDevices && (
                    <MenuItem
                        onClick={() => {
                            onViewDevices(user)
                            handleMenuClose()
                        }}
                    >
                        Visa enheter ({user.deviceCount ?? 0})
                    </MenuItem>
                )}
            </Menu>
        </Box>
    )
}

export default UserActionsMenu
